export {};
//# sourceMappingURL=target-map.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/target-map.interface.js
// module id = 801
// module chunks = 3